import { FC } from 'react'
import { useAppDispatch, useAppSelector } from '../../hooks'
import {
  hideMessageNavigationDialogAction,
} from '../../store/messageNavigationDialog'
import {
  MessageNavigationDialog,
  toAbsoluteAppUrl,
} from './MessageNavigationDialog'

const MessageNavigationDialogHost: FC = () => {
  const dispatch = useAppDispatch()
  const { open, message, variant, path, actionTitle } = useAppSelector(
    (state) => state.messageNavigationDialog
  )

  const onClose = () => dispatch(hideMessageNavigationDialogAction())

  const onConfirm = () => {
    const url = toAbsoluteAppUrl(path)
    if (url) {
      window.location.assign(url)
    }
    onClose()
  }

  return (
    <MessageNavigationDialog
      open={open}
      message={message}
      variant={variant}
      path={path}
      actionTitle={actionTitle}
      onClose={onClose}
      onConfirm={onConfirm}
    />
  )
}

export default MessageNavigationDialogHost
